import { render } from "./GroupsList.vue?vue&type=template&id=146c8784&scoped=true"
import script from "./GroupsList.vue?vue&type=script&lang=js"
export * from "./GroupsList.vue?vue&type=script&lang=js"

import "./GroupsList.vue?vue&type=style&index=0&id=146c8784&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-146c8784"]])

export default __exports__